import React, { useEffect, useState, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import {
  get_budget_list,
  deactivate_subhead_budget,
} from "../../../helper/Api";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaEdit } from "react-icons/fa";
import { Accordion } from "react-bootstrap";
import {
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import BudgetListOverlay from "./SchemeComponents/BudgetListOverlay";
import Spinner from "../../Tools/spinner";
import { AddCommasToAmount } from "../../../helper/Utils";



const BudgetListNew = (listType) => {
  const { authData, financialYears } = useSelector((state) => state.authData);
  const [loading, setLoading] = useState(false);
  const [budgets, setBudgets] = useState([]);
  const [overlay, setOverlay] = useState(true);
  const [overlayDropDown, setOverlayDropDown] = useState(false);
  const globalDateId = localStorage.getItem("globalDateId");
  const [activeCard, setActiveCard] = useState([]);
  const [archiveConfirmOpen, setArchiveConfirmOpen] = useState(false);
  const [pendingArchiveBudgetId, setPendingArchiveBudgetId] = useState(null);
  const [archiving, setArchiving] = useState(false);
  const navigate = useNavigate();
  const totalRef = useRef({
    provisional_budget: 0,
    budget: 0
  });

  const formatAmount = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return AddCommasToAmount(value);
  };

function getFinancialYearDates(year) {
  const startDate = `${year}-04-01`;
  const endDate = `${parseInt(year) + 1}-03-31`;
  return { startDate, endDate };
}

  // NOTE: For Budgets page we apply only department_id (dates are ignored).
  const fetchBudgets = useCallback(async (fromDate, toDate, searchStr, fyId, department_id) => {
      try {
        setLoading(true);
        let fy_id_default = localStorage.getItem("globalDateId");
        let fyRecord = getFinancialYearDates(financialYears.payload.fy_list.find(e => e.id === fy_id_default).start_year);
        const post_data = new FormData();
        // Always use FY range, ignore fromDate/toDate filters.
        post_data.append("from_date", fyRecord?.startDate);
        post_data.append("to_date", fyRecord?.endDate);
        post_data.append("search_str", searchStr || "");
        // post_data.append("fy_id", fyId || "");
        post_data.append("department_id", department_id || authData.user.department_id || "");
        const { data } = await get_budget_list(post_data, "");
        if (data.budgets) {
          let budgetRecords = data.budgets;
          budgetRecords.reduce((acc, curr) => {
              acc.provisional_budget += Number(curr.provisional_budget || 0);
              acc.budget += Number(curr.budget || 0);
              return acc;
            },
            { provisional_budget: 0, budget: 0 }
          );

          const groupedBySchemeId = {};
          totalRef.current.provisional_budget = 0;
          totalRef.current.budget = 0;
          budgetRecords.forEach((budget) => {
            const schemeId = budget.scheme_id;
            totalRef.current.provisional_budget += Number(budget.subhead_provisional_budget);
            totalRef.current.budget += Number(budget.budget);

            if (!groupedBySchemeId[schemeId]) {
              groupedBySchemeId[schemeId] = {
                records: [],
                subheadMap: {}
              };
            }

            groupedBySchemeId[schemeId].records.push(budget);

            const subheadId = budget.subhead_id;
            const subheadName = budget.subhead_name;
            const budgetAmount = parseFloat(budget.budget || 0);
            const provBudget = parseFloat(budget.subhead_provisional_budget || 0);

            if (!groupedBySchemeId[schemeId].subheadMap[subheadId]) {
              groupedBySchemeId[schemeId].subheadMap[subheadId] = {
                subhead_name: subheadName,
                provisional_budget: provBudget,
                budget: budgetAmount,
                activitiesMap: {} // For unique activity tracking
              };
            } else {
              groupedBySchemeId[schemeId].subheadMap[subheadId].provisional_budget += provBudget;
              groupedBySchemeId[schemeId].subheadMap[subheadId].budget += budgetAmount;
            }

            // Handle activities inside this budget
            (budget.activities || []).forEach((act) => {
              const activityKey = act.activity;

              const subBudget = parseFloat(act.budget || 0);
              const subProvBudget = parseFloat(act.provisional_budget || 0);

              let activitiesMap = groupedBySchemeId[schemeId].subheadMap[subheadId].activitiesMap;

              // Initialize activity if not present
              if (!activitiesMap[activityKey]) {
                activitiesMap[activityKey] = {
                  activity: act.activity,
                  budget: 0,
                  provisional_budget: 0,
                  subactivities: {}
                };
              }

              // Add to total
              activitiesMap[activityKey].budget += subBudget;
              activitiesMap[activityKey].provisional_budget += subProvBudget;

              // Group subactivity now
              const subKey = act.subactivity;

              if (!activitiesMap[activityKey].subactivities[subKey]) {
                activitiesMap[activityKey].subactivities[subKey] = {
                  subactivity: act.subactivity,
                  budget: subBudget,
                  provisional_budget: subProvBudget
                };
              } else {
                activitiesMap[activityKey].subactivities[subKey].budget += subBudget;
                activitiesMap[activityKey].subactivities[subKey].provisional_budget += subProvBudget;
              }
            });
          });

          // Final transformation
          const groupedArray = Object.entries(groupedBySchemeId).map(([scheme_id, data]) => ({
            scheme_id,
            records: data.records,
            subheads: Object.values(data.subheadMap).map((sub) => ({
              subhead_name: sub.subhead_name,
              provisional_budget: sub.provisional_budget,
              budget: sub.budget,
              activities: Object.values(sub.activitiesMap).map((act) => ({
                activity: act.activity,
                budget: act.budget,
                provisional_budget: act.provisional_budget,
                subactivities: Object.values(act.subactivities)
              }))
            }))
          }));
          setBudgets(groupedArray);
          setLoading(false);
        }
      } catch (error) {
        setBudgets([]);
        setLoading(false);
      }
    },
    [authData, setBudgets]
  );

  useEffect(() => {
    fetchBudgets(
      listType.fromDate,
      listType.toDate,
      listType.searchStr,
      listType.fyId,
      listType.departmentId
    );
  }, [
    fetchBudgets,
    globalDateId,
    listType.searchStr,
    listType.fyId,
    listType.departmentId,
  ]);

  const openArchiveConfirm = (budgetId) => {
    if (!budgetId) {
      toast.error("Budget id is required.", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    setPendingArchiveBudgetId(budgetId);
    setArchiveConfirmOpen(true);
  };

  const closeArchiveConfirm = () => {
    if (archiving) return;
    setArchiveConfirmOpen(false);
    setPendingArchiveBudgetId(null);
  };

  const confirmArchiveBudget = async () => {
    if (!pendingArchiveBudgetId) {
      toast.error("Budget id is required.", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    try {
      setArchiving(true);
      setLoading(true);
      const response = await deactivate_subhead_budget({
        subhead_budget_id: pendingArchiveBudgetId,
      });

      if (response?.data?.status) {
        toast.success(response.data.message || "Budget archived successfully.", {
          position: toast.POSITION.TOP_CENTER,
        });
        setArchiveConfirmOpen(false);
        setPendingArchiveBudgetId(null);
        await fetchBudgets(
          listType.fromDate,
          listType.toDate,
          listType.searchStr,
          listType.fyId,
          listType.departmentId
        );
      } else {
        toast.error(response?.data?.message || "Failed to archive budget.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || error?.message || "Failed to archive budget.",
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );
    } finally {
      setArchiving(false);
      setLoading(false);
    }
  };

  const fy_list = listType.fy_list;
  const toggleAccordion = (key) => {
    setActiveKeys(
      (prevKeys) =>
        prevKeys.includes(key)
          ? prevKeys.filter((k) => k !== key) // Remove key if it's already open
          : [...prevKeys, key] // Add key if it's closed
    );
  };

  const [activeKeys, setActiveKeys] = useState([]); // Initially open accordions

  const handleSubCardChange = (val1, val2, val3) => {
    setActiveCard((prev) => {
      let updated = [...prev];
      // Remove val2 and val3 if present
      updated = updated.filter(item => item !== val2 && item !== val3);
      // Add val1 if not already present
      if (!updated.includes(val1)) {
        updated.unshift(val1); // Add at the beginning
      }
      return updated;
    });
  }
  const [schemeBudgetRef, setSchemeBudgetRef] = useState({});
  const handleBudgetListOverlay = (schemeBudget, id=null) => {
    setOverlay(false);
    if(id) {
      const rc = schemeBudget.records.find(e => Number(e.id) === Number(id))
      setSchemeBudgetRef({ records: [rc] });
    }
  }

  const handleBudgetDocumentUpdated = (budgetId, documentRef) => {
    const nextAttachments = [{ file_url: documentRef }];
    setSchemeBudgetRef((prev) => ({
      ...prev,
      records: (prev?.records || []).map((record) => (
        String(record?.id) === String(budgetId)
          ? { ...record, attachments: nextAttachments }
          : record
      )),
    }));
    setBudgets((prev) => prev.map((scheme) => ({
      ...scheme,
      records: (scheme.records || []).map((record) => (
        String(record?.id) === String(budgetId)
          ? { ...record, attachments: nextAttachments }
          : record
      )),
    })));
  };
  return (
    <div>
      {loading && <Spinner />}
      <div className="row">
        <div
          className="px-3 col-9 d-flex flex-column gap-3 overflow-y-auto overflow-x-hidden"
          style={{ height: "100vh" }}
        >
          {
            budgets.map((schemeBudget, index) => (
              <div
                className={`hover-card bg-white border-Prime-100`}
                style={{ borderRadius: "8px" }}
                key={index}
              >
                <div
                  className="bg-prime-20 d-flex justify-content-between align-items-center p-2 hover-card-color transition overflow-hidden position-relative"
                  style={{ borderRadius: "8px 8px 0 0" }}
                >
                  {/* =======================card header====================== */}
                  <span
                    className={`fs-14px white-space-nowrap overflow-x-hidden text-overflow-ellipsis`}
                    style={{ width: "95%", fontStyle: "italic" }}
                  >
                    <span
                      className={`text-secondary-100 text-white-hover transition text-overflow-ellipsis `}
                      style={{ fontStyle: "italic" }}
                    >
                      Scheme code- {schemeBudget.records[0]?.scheme_code} {schemeBudget.records[0]?.scheme_name}
                    </span>
                  </span>

                  <span className="position-absolute end-0 me-2">
                    <i
                      className="icon-grading cursor-pointer"
                      onClick={() => handleBudgetListOverlay(schemeBudget)}
                    ></i>
                  </span>
                </div>

                {/* =============================data============ */}


                <div className="row p-2 text-start m-0 ">
                  <div style={{ overflowX: "auto" }} className="w-100">
                    <table style={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse" }}>
                      <colgroup>
                        <col style={{ width: "50px" }} />
                        <col />
                        <col style={{ width: "110px" }} />
                        <col style={{ width: "130px" }} />
                        <col style={{ width: "130px" }} />
                        <col style={{ width: "170px" }} />
                      </colgroup>
                      <thead>
                        <tr style={{ border: "0" }} className="p-0 m-0">
                          <th className="fs-12px text-black-60 border-0 p-1 text-center">
                            Sr. No.
                          </th>
                          <th className="fs-12px text-black-60 border-0 p-1 text-start">
                            Order No
                          </th>
                          <th className="fs-12px text-black-60 border-0 p-1 text-center">
                            Order Date
                          </th>
                          <th className="fs-12px text-black-60 border-0 p-1 text-end">
                            Provisioned
                          </th>
                          <th className="fs-12px text-black-60 border-0 p-1 text-end">
                            Released
                          </th>
                          <th className="fs-12px text-black-60 border-0 p-1 text-center" style={{ whiteSpace: "nowrap" }}>
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          schemeBudget.records.map((budget, idx) => (
                            <tr key={idx} >
                              <td className="fs-14px border-0 p-1 text-center align-middle">{idx + 1}</td>
                              <td
                                className="fs-14px border-0 p-1 text-start align-middle"
                                style={{ wordBreak: "break-word", whiteSpace: "normal" }}
                                title={budget.budget_order_no}
                              >
                                {budget.budget_order_no}
                              </td>
                              <td className="fs-14px border-0 p-1 text-center align-middle">{budget.budget_order_date}</td>
                              <td className="fs-14px border-0 p-1 text-end align-middle">
                                {formatAmount(budget.subhead_provisional_budget)}
                              </td>
                              <td className="fs-14px border-0 p-1 text-end align-middle">
                                {formatAmount(budget.budget)}
                              </td>
                              <td className="fs-14px border-0 p-1 text-center align-middle" style={{ whiteSpace: "nowrap" }}>
                                <div className="d-flex align-items-center justify-content-center gap-1">
                                  <div
                                    className="d-flex align-items-center gap-1"
                                    style={{ width: "96px", flexShrink: 0 }}
                                  >
                                    <button
                                      className={`${
                                        budget.l2_status === "1"
                                          ? "bg-success-20"
                                          : budget.l2_status === "2"
                                          ? "bg-danger-20"
                                          : "bg-warning-20"
                                      } rounded-1 border-0 px-2 py-1 fs-12px d-flex justify-content-center align-items-center gap-1`}
                                      style={{ minWidth: "46px" }}
                                      onClick={() => {
                                        Number(budget.l2_status) === 0 && navigate(`/view-budget/${budget.id}`);
                                      }}
                                    >
                                      L2{" "}
                                      <i
                                        className={`${
                                          budget.l2_status === "1"
                                            ? "icon-verified text-success-100"
                                            : budget.l2_status === "2"
                                            ? "icon-warning_amber text-danger-100"
                                            : "icon-warning_amber text-warning-100"
                                        } fs-16px`}
                                      ></i>
                                    </button>

                                    <button
                                      className={`${
                                        budget.l3_status === "1"
                                          ? "bg-success-20"
                                          : budget.l3_status === "2"
                                          ? "bg-danger-20"
                                          : "bg-warning-20"
                                      } rounded-1 border-0 px-2 py-1 fs-12px d-flex justify-content-center align-items-center gap-1`}
                                      style={{ minWidth: "46px" }}
                                      onClick={() => {
                                        Number(budget.l3_status) === 0 && navigate(`/view-budget/${budget.id}`);
                                      }}
                                    >
                                      L3{" "}
                                      <i
                                        className={`${
                                          budget.l3_status === "1"
                                            ? "icon-verified text-success-100"
                                            : budget.l3_status === "2"
                                            ? "icon-warning_amber text-danger-100"
                                            : "icon-warning_amber text-warning-100"
                                        } fs-16px`}
                                      ></i>
                                    </button>
                                  </div>

                                  <div
                                    className="d-flex align-items-center"
                                    style={{ width: "66px", flexShrink: 0 }}
                                  >
                                    <span
                                      className="d-inline-flex justify-content-center align-items-center"
                                      style={{ width: "22px", height: "22px" }}
                                    >
                                      <Tooltip title="View" arrow>
                                        <i
                                          className="icon-remove_red_eye text-info-100 cursor-pointer"
                                          onClick={() => handleBudgetListOverlay(budgets[index], budget.id)}
                                        ></i>
                                      </Tooltip>
                                    </span>
                                    <span
                                      className="d-inline-flex justify-content-center align-items-center"
                                      style={{ width: "22px", height: "22px" }}
                                    >
                                      {!(budget.l2_status === "1" && budget.l3_status === "1") ? (
                                        <Tooltip title="Archive" arrow>
                                          <i
                                            className="icon-archive text-danger cursor-pointer"
                                            onClick={() => openArchiveConfirm(budget.id)}
                                          ></i>
                                        </Tooltip>
                                      ) : null}
                                    </span>
                                    <span
                                      className="d-inline-flex justify-content-center align-items-center"
                                      style={{ width: "22px", height: "22px" }}
                                    >
                                      {(budget.l2_status === "2" || budget.l3_status === "2") &&
                                      authData.user.user_type === "l1" ? (
                                        <Tooltip title="Edit" arrow>
                                          <Link to={`/edit-budget/${budget.id}`} className="d-inline-flex">
                                            <FaEdit />
                                          </Link>
                                        </Tooltip>
                                      ) : null}
                                    </span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                      <tfoot>
                        {(() => {
                          const totals = schemeBudget.records.reduce(
                            (acc, curr) => {
                              acc.provisional_budget += Number(curr.subhead_provisional_budget || 0);
                              acc.budget += Number(curr.budget || 0);
                              return acc;
                            },
                            { provisional_budget: 0, budget: 0 }
                          );

                          return (
                            <tr className="bg-info-20">
                              <td className="fs-14px border-0 p-1 text-center align-middle text-prime-100 fw-semibold" colSpan={3}>
                                Total
                              </td>
                              <td className="fs-14px border-0 p-1 text-end align-middle fw-semibold">
                                {formatAmount(totals.provisional_budget)}
                              </td>
                              <td className="fs-14px border-0 p-1 text-end align-middle fw-semibold">
                                {formatAmount(totals.budget)}
                              </td>
                              <td className="fs-14px border-0 p-1"></td>
                            </tr>
                          );
                        })()}
                      </tfoot>
                      </table>
                    </div>
                  
                </div>

                {/* ================== card body ========================= */}

                <div className="px-2 m-0">
                  <div className="border mb-2"></div>

                  <div className="pb-2 d-flex justify-content-between text-secondary-50 px-4">
                    {
                      (!activeCard.includes(`subhead_${schemeBudget.records[0]?.id}`)) ? 
                      <button
                        onClick={() => handleSubCardChange(`subhead_${schemeBudget.records[0]?.id}`, `activity_${schemeBudget.records[0]?.id}`, `subactivity_${schemeBudget.records[0]?.id}`)}
                        className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                          activeCard.includes(`subhead_${schemeBudget.records[0]?.id}`) ? "bg-secondary-20" : "bg-white"
                        } `}
                      >
                        {activeCard.includes(`subhead_${schemeBudget.records[0]?.id}`) ? (<i className="icon-remove_circle_outline"></i>) : (<i className="icon-add_circle_outline"></i>)}
                        Sub head
                      </button>
                      : 
                      <button
                        
                        className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                          activeCard.includes(`subhead_${schemeBudget.records[0]?.id}`) ? "bg-secondary-20" : "bg-white"
                        } `}
                      >
                        {activeCard.includes(`subhead_${schemeBudget.records[0]?.id}`) ? (
                          <i className="icon-remove_circle_outline"></i>
                        ) : (
                          <i className="icon-add_circle_outline"></i>
                        )}
                        Sub head
                      </button>
                    }
                    {/* activity button */}
                    {schemeBudget.records[0]?.is_activity_active === '1' && 
                      <>
                      {
                        (!activeCard.includes(`activity_${schemeBudget.records[0]?.id}`)) ? (<button
                          onClick={() => handleSubCardChange(`activity_${schemeBudget.records[0]?.id}`, `subhead_${schemeBudget.records[0]?.id}`, `subactivity_${schemeBudget.records[0]?.id}`)}
                          className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                            activeCard.includes(`activity_${schemeBudget.records[0]?.id}`) ? "bg-secondary-20" : "bg-white"
                          } `}
                        >
                          {activeCard.includes(`activity_${schemeBudget.records[0]?.id}`) ? (
                            <i className="icon-remove_circle_outline"></i>
                          ) : (
                            <i className="icon-add_circle_outline"></i>
                          )}
                          Activity
                        </button>)  : (<button
                          className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                            activeCard.includes(`activity_${schemeBudget.records[0]?.id}`) ? "bg-secondary-20" : "bg-white"
                          } `}
                        >
                          {activeCard.includes(`activity_${schemeBudget.records[0]?.id}`) ? (
                            <i className="icon-remove_circle_outline"></i>
                          ) : (
                            <i className="icon-add_circle_outline"></i>
                          )}
                          Activity
                        </button>) 
                      }
                        
                      {
                        (!activeCard.includes(`subactivity_${schemeBudget.records[0]?.id}`)) ? ( <button
                        onClick={() => handleSubCardChange(`subactivity_${schemeBudget.records[0]?.id}`, `activity_${schemeBudget.records[0]?.id}`, `subhead_${schemeBudget.records[0]?.id}`)}
                        className={` ${
                          activeCard.includes(`subactivity_${schemeBudget.records[0]?.id}`) ? "bg-secondary-20" : "bg-white"
                        } 
                      border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                      >
                        {activeCard.includes(`subactivity_${schemeBudget.records[0]?.id}`) ? (
                          <i className="icon-remove_circle_outline"></i>
                        ) : (
                          <i className="icon-add_circle_outline"></i>
                        )}
                        Sub-Activity
                      </button>) :
                      ( <button
                        className={` ${
                          activeCard.includes(`subactivity_${schemeBudget.records[0]?.id}`) ? "bg-secondary-20" : "bg-white"
                        } 
                      border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                      >
                        {activeCard.includes(`subactivity_${schemeBudget.records[0]?.id}`) ? (
                          <i className="icon-remove_circle_outline"></i>
                        ) : (
                          <i className="icon-add_circle_outline"></i>
                        )}
                        Sub-Activity
                      </button>)
                      }
                      </>}
                    </div>
                </div>

                {/* ===================card footer ==================== */}

                {activeCard.includes(`subhead_${schemeBudget.records[0]?.id}`) && (
                  <>
                    <div className="border mx-2"></div>
                    <div className="row p-2 text-start">
                      <div className="col-5 d-flex flex-column">
                        <span className="fs-12px text-black-60"> Sub Head</span>
                        {
                          schemeBudget.subheads.map((budget, idx) => (
                            <>
                              <span className="fs-14px fw-500">{budget.subhead_name}</span>
                            </>
                          ))
                        }
                      </div>

                      <div className="col d-flex flex-column">
                        <span className="fs-12px text-black-60"> Provisional</span>
                        {
                          schemeBudget.subheads.map((budget, idx) => (
                            <>
                              <span className="fs-14px fw-500">
                                {formatAmount(budget.provisional_budget)}
                              </span>
                            </>
                          ))
                        }
                      </div>

                      <div className="col d-flex flex-column">
                        <span className="fs-12px text-black-60">Released</span>
                        {
                          schemeBudget.subheads.map((budget, idx) => (
                            <>
                              <span className="fs-14px fw-500">
                                {formatAmount(budget.budget)}
                              </span>
                            </>
                          ))
                        }
                      </div>
                    </div>
                  </>
                )}
                {activeCard.includes(`activity_${schemeBudget.records[0]?.id}`) && (
                  <>
                    <div className="border mx-2"></div>
                    <div className=" pb-2 d-flex flex-column gap-1 mt-2 mx-0 px-2">
                      {
                          schemeBudget.subheads.map((budget, idx) => (
                            <Accordion style={{ border: "0" }}>
                              <Accordion.Item
                                eventKey={`suubhead_activity_${idx}`}
                                style={{ borderRadius: "0", border: "0" }}
                              >
                                <Accordion.Header
                                  onClick={() => toggleAccordion(`suubhead_activity_${idx}`)}
                                >
                                  <div className="w-100 d-flex justify-content-between">
                                    <span>{budget.subhead_name}</span>
                                    <span
                                      className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                      style={{
                                        height: "13.33px",
                                        width: "13.33px",
                                      }}
                                    >
                                      {activeKeys.includes(`suubhead_activity_${idx}`) ? "-" : "+"}
                                    </span>
                                  </div>
                                </Accordion.Header>

                                <Accordion.Body>
                                  <div>
                                    {
                                      <div className="row my-1 p-0 mx-0">
                                        <div className="row p-2 text-start">
                                          <div className="col-5 d-flex flex-column">
                                            <span className="fs-12px text-black-60">
                                              {" "}
                                              Activity
                                            </span>
                                              {
                                                budget.activities.map((activity) => (
                                                  <span className="fs-14px fw-600">{activity.activity}</span>
                                                ))
                                              }
                                          </div>

                                          <div className="col d-flex flex-column">
                                            <span className="fs-12px text-black-60">
                                              {" "}
                                              Provisional
                                            </span>
                                            {
                                              budget.activities.map((activity) => (
                                                <span className="fs-14px fw-600">
                                                  {formatAmount(activity.provisional_budget)}
                                                </span>
                                              ))
                                            }
                                          </div>

                                          <div className="col d-flex flex-column">
                                            <span className="fs-12px text-black-60">
                                              Released
                                            </span>
                                            {
                                              budget.activities.map((activity) => (
                                                <span className="fs-14px fw-600">
                                                  {formatAmount(activity.budget)}
                                                </span>
                                              ))
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          ))
                        }
                      
                    </div>
                  </>
                )}
                {activeCard.includes(`subactivity_${schemeBudget.records[0]?.id}`) && (
                  <>
                    <div className="border mx-2"></div>
                    <div className=" pb-2 d-flex flex-column gap-1 mt-2 mx-0 px-2">
                      {
                        schemeBudget.subheads.map((budget, idx) => 
                            budget.activities.map((activity, activity_idx) => (
                              <Accordion style={{ border: "0" }}>
                                <Accordion.Item
                                  eventKey={`subhead_subactivity_${idx}_${activity_idx}`}
                                  style={{ borderRadius: "0", border: "0" }}
                                >
                                  <Accordion.Header
                                    onClick={() => toggleAccordion(`subhead_subactivity_${idx}_${activity_idx}`)}
                                  >
                                    <div className="w-100 d-flex justify-content-between">
                                      <span>{budget.subhead_name} | {activity.activity}</span>
                                      <span
                                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                        style={{
                                          height: "13.33px",
                                          width: "13.33px",
                                        }}
                                      >
                                        {activeKeys.includes(`subhead_subactivity_${idx}_${activity_idx}`) ? "-" : "+"}
                                      </span>
                                    </div>
                                  </Accordion.Header>

                                  <Accordion.Body>
                                    <div>
                                      {
                                        <div className="row my-1 p-0 mx-0">
                                          <div className="row p-2 text-start">
                                            <div className="col-12 d-flex flex-column">
                                              <table className="table nested_table_default">
                                                <thead>
                                                  <tr>
                                                    <th>Sub Activity</th>
                                                    <th>Provisional</th>
                                                    <th>Released</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {
                                                    activity.subactivities.map((subactivity) => (
                                                      <tr>
                                                        <td><span className="fs-14px fw-600">{subactivity.subactivity}</span></td>
                                                        <td>
                                                          <span className="fs-14px fw-600">
                                                            {formatAmount(subactivity.provisional_budget)}
                                                          </span>
                                                        </td>
                                                        <td>
                                                          <span className="fs-14px fw-600">
                                                            {formatAmount(subactivity.budget)}
                                                          </span>
                                                        </td>
                                                      </tr>
                                                    ))
                                                  }
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                            ))
                          )
                      }
                    </div>
                  </>
                )}
              </div>
            ))
          }
          
        </div>

        {/* ================== right side bar ================== */}

        <div className="col-3 px-3 pb-2 m-0">
          <div className="totals">
            <div
              className="bg-success-20 p-3 d-flex flex-column"
              style={{
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            >
              <span className="text-success-100 fs-12px">
                Total Provisional Budget FY{" "}
                {fy_list?.map((val, ind) => {
                  return val?.id == globalDateId && val?.year;
                })}
              </span>
              <span className="text-success-100 fs-20px ">
                {formatAmount(totalRef.current.provisional_budget)}
              </span>
            </div>

            <div
              className="bg-info-20 p-3 d-flex flex-column "
              style={{
                borderTop: "1px solid #0DCAF0",
              }}
            >
              <span className="text-black-60 fs-12px">
                Total Released Budget FY{" "}
                {fy_list?.map((val, ind) => {
                  return val?.id == globalDateId && val?.year;
                })}
              </span>
              <span className="fs-20px  text-success-100 ">
                {formatAmount(totalRef.current.budget)}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* ==============================overlay====================== */}

      <BudgetListOverlay 
        overlay={overlay}
        setOverlay={setOverlay}
        overlayDropDown={overlayDropDown}
        setOverlayDropDown={setOverlayDropDown}
        setActiveCard={setActiveCard}
        schemeBudgetRef={schemeBudgetRef}
        onDocumentUpdated={handleBudgetDocumentUpdated}
      />

      <Dialog
        open={archiveConfirmOpen}
        onClose={closeArchiveConfirm}
        maxWidth="xs"
        fullWidth
        aria-labelledby="archive-budget-title"
      >
        <DialogTitle id="archive-budget-title">Archive budget</DialogTitle>
        <DialogContent dividers>
          <p className="mb-0" style={{ fontSize: 15, lineHeight: 1.5 }}>
            Are you sure you want to archive this budget record? Once archived,
            you will not be able to get it back.
          </p>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2 }}>
          <Button onClick={closeArchiveConfirm} color="inherit" disabled={archiving}>
            Cancel
          </Button>
          <Button
            onClick={confirmArchiveBudget}
            variant="contained"
            color="error"
            disabled={archiving}
          >
            {archiving ? "Archiving..." : "Yes, archive"}
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default BudgetListNew;
